export const icons = {
    location: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 21s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"></path>
    <circle cx="12" cy="9" r="2.3"></circle>
  </svg>`,
    phone: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"></path>
  </svg>`,
    mail: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2.5"></rect>
    <path d="M3.5 6.2l8.5 6.8 8.5-6.8"></path>
  </svg>`,
    instagram: `<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="4.5" width="18" height="15" rx="4.5"></rect>
    <circle cx="12" cy="12" r="3.8"></circle>
    <circle cx="16.4" cy="7.8" r="0.35" fill="currentColor" stroke="none"></circle>
  </svg>`,
    facebook: `<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
    <path d="M15.5 8.2h-1.8c-.7 0-1.2.55-1.2 1.3v1.9H15.5l-.35 2.4h-2.65V21H10V13.8H7.9v-2.4H10V9.2C10 7 11.7 5.2 13.9 5.2h1.6v3z"></path>
  </svg>`
};
